import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useEffect, useRef } from 'react';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ISelectedCategory {
  selectedCategory: IBurgerMenuItem;
  itemNavigationHandler: Function;
}

export const SelectedCategory = ({
  selectedCategory,
  itemNavigationHandler,
}: ISelectedCategory) => {
  const selectedCategoryRef = useRef<any>(null);

  useEffect(() => {
    if (selectedCategoryRef.current) selectedCategoryRef.current.focus();
  }, []);

  return (
    <>
      <Stack
        sx={{
          flexDirection: 'row',
          mt: '16px',
          p: '16px 20px',
          width: 'calc(100% + 33px)',
          justifyContent: 'flex-start',
          gap: '10px',
          bgcolor: 'primary.shade_100',
          borderRadius: '0px 34px 34px 0px',
        }}
        ref={selectedCategoryRef}
        tabIndex={-1}
      >
        <Avatar
          sx={{ width: '24px', height: '24px' }}
          src={selectedCategory.mobileIconUrl}
          alt=''
        />
        <Typography variant='body3' color='initial'>
          {selectedCategory.description}
        </Typography>
      </Stack>
      <Stack
        sx={{
          mt: '24px',
        }}
      >
        {selectedCategory?.subItems?.map(
          (subItem: IBurgerMenuItem, index: number) => (
            <Button
              key={index}
              sx={{ width: 'fit-content' }}
              onClick={() => itemNavigationHandler(subItem)}
              onKeyDown={onEnterOrEscapeKeyDown}
              role='link'
            >
              <Typography color={'initial'} variant='body3'>
                {subItem.description}
              </Typography>
              {subItem.isNewItem && (
                <Box
                  sx={{
                    display: 'inline-block',
                    padding: '0 10px',
                    mr: '10px',
                    fontWeight: 700,
                    fontSize: '16px',
                    bgcolor: 'purple2.shade_400',
                    color: 'white',
                    borderRadius: '0 12px 0 12px',
                  }}
                >
                  {Dictionary[DICTIONARY.General].sidebar.new}
                </Box>
              )}
            </Button>
          ),
        )}
      </Stack>
    </>
  );
};
